/**
 * `u` when it is an absolute http(s) URL, else null (other schemes,
 * relative URLs, unparseable text). The one test for URLs from content or
 * integrations before they become a link or an image.
 */
export function httpUrl(u: string | null | undefined): string | null {
  if (!u) return null;
  try {
    const { protocol } = new URL(u);
    return protocol === 'http:' || protocol === 'https:' ? u : null;
  } catch {
    return null;
  }
}
